import type { RouteRecordRaw } from 'vue-router'

interface RouteConfig {
  path: string
  name?: string
  component: () => Promise<typeof import('*.vue')>
  meta?: Record<string, any>
}

function createRoutes(basePath: string, routes: RouteConfig[]): RouteRecordRaw[] {
  return routes.map(
    ({ path, name, component, meta }): RouteRecordRaw => ({
      path: `${basePath}${path}`,
      name,
      component,
      ...(meta && { meta }),
    }),
  )
}

// Main routes
const mainRoutes: RouteConfig[] = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/components/pages/home/Index.vue'),
  },
  {
    path: '/delegations',
    name: 'Delegations',
    component: () => import('@/components/pages/delegations/Index.vue'),
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('@/components/pages/notifications/Index.vue'),
  },
]

// Detail and Report routes
const viewRoutes: RouteConfig[] = [
  {
    path: '/detail/:id',
    component: () => import('@/components/pages/detail/Index.vue'),
  },
  {
    path: '/report/:id',
    component: () => import('@/components/pages/reports/Index.vue'),
  },
]

// Form routes
const formRoutes = createRoutes('/form', [
  {
    path: '/:formId',
    component: () => import('@/components/pages/form/Index.vue'),
  },
  {
    path: '/:formId/identity/:identityId',
    component: () => import('@/components/pages/form/Index.vue'),
  },
])

const workflowRoutes = createRoutes('/workflows', [
  {
    path: '/link/:id',
    component: () => import('@/components/pages/workflows/Index.vue'),
  },
])

// Feature-specific routes
const policyRoutes = createRoutes('/policies', [
  { path: '', name: 'Policies', component: () => import('@/components/pages/policies/Index.vue') },
  {
    path: '/create',
    name: 'Policy Creation',
    component: () => import('@/components/pages/policies/Create.vue'),
  },
  {
    path: '/:id/edit',
    name: 'Policy Edit',
    component: () => import('@/components/pages/policies/Edit.vue'),
  },
])

const campaignRoutes = createRoutes('/campaigns', [
  {
    path: '',
    name: 'Campaigns',
    component: () => import('@/components/pages/campaigns/Index.vue'),
  },
  {
    path: '/create',
    name: 'Campaign Creation',
    component: () => import('@/components/pages/campaigns/Create.vue'),
  },
  {
    path: '/:id/edit',
    name: 'Campaign Edit',
    component: () => import('@/components/pages/campaigns/Edit.vue'),
  },
  {
    path: '/:id/instance/:instanceId',
    name: 'Campaign Instance',
    component: () => import('@/components/pages/campaigns/Instance.vue'),
  },
])

const searchRoutes = createRoutes('/search', [
  { path: '', name: 'Search', component: () => import('@/components/pages/search/Index.vue') },
])

// Combine all routes
export const routeConfig: RouteRecordRaw[] = [
  ...mainRoutes,
  ...viewRoutes,
  ...formRoutes,
  ...campaignRoutes,
  ...policyRoutes,
  ...searchRoutes,
  ...workflowRoutes,
]
